import type { ReactNode } from 'react';
import * as React from 'react';
import { useState } from 'react';

import { type MobileMainIdentifierValues } from 'bundles/composable-page-header/constants';
import type { ToParentPage, ToSubPage } from 'bundles/composable-page-header/contexts/MobileNavigationContext';
import MobileNavigationContext, {
  useCloseMobileMenu,
  useGetOnSubNav,
  useSetIsOnSubNav,
} from 'bundles/composable-page-header/contexts/MobileNavigationContext';

type Props = {
  children: ReactNode;
  subPagesMap: Partial<Record<MobileMainIdentifierValues, ReactNode>>;
};
const MobileMenuConfigWrapper = ({ children, subPagesMap }: Props) => {
  const [currentView, setCurrentView] = useState<MobileMainIdentifierValues>();
  const closeMobileMenu = useCloseMobileMenu();
  const setIsSubNav = useSetIsOnSubNav();
  const onSubNav = useGetOnSubNav();

  const toSubPage: ToSubPage = (pageIdentity: MobileMainIdentifierValues) => {
    setIsSubNav?.(true);
    setCurrentView(pageIdentity);
  };

  const toParentPage: ToParentPage = (pageIdentity: MobileMainIdentifierValues) => {
    setCurrentView(pageIdentity);
    setIsSubNav?.(false);
  };

  const renderView = () => {
    if (currentView && onSubNav && subPagesMap?.[currentView]) {
      return subPagesMap[currentView];
    } else {
      return children;
    }
  };

  return (
    <MobileNavigationContext.Provider value={{ toSubPage, toParentPage, closeMobileMenu }}>
      {renderView()}
    </MobileNavigationContext.Provider>
  );
};

export default MobileMenuConfigWrapper;
